import Vue from 'vue'
import VueRouter from 'vue-router'
import { getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import { canNavigate } from '@/libs/acl/routeProtection'

import auth from './auth'
import beritaAcara from './beritaAcara'
import cetakBarcode from './cetakBarcode'
import cetakDaftarBmd from './cetakDaftarBmd'
import cetakQrCode from './cetakQrCode'
import dataInformasi from './dataInformasi'
import monitoring from './monitoring'
import validasiBelumTercatat from './validasiBelumTercatat'
import validasiKeberadaan from './validasiKeberadaan'
import sptjm from './sptjm'
import laporan from './laporan'
import perkin from './perkin'
import pengembalian from './koreksi/pengembalian'
import cleansing from './koreksi/cleansing'

/* Master */
import masterJenisRuangan from './master/jenisRuangan'

/* General */
import log from './general/log'
import bypass from './general/bypass'

/* B */
import bSkTim from './b/skTim'
import bPendalamanRegister from './b/pendalamanRegister'
import daftarBmd from './b/daftarBmd'
import bDashboard from './b/dashboard'
import hasilSensus from './b/hasilSensus'
import bMonitoring from './b/monitoring'
import bPerkin from './b/perkin'
import bDokumenInventarisasi from './b/dokumenInventarisasi'
import bRuangan from './b/ruangan'
import bBeritaAcaraHasilInventarisasi from './b/beritaAcaraHasilInventarisasi'
/* C */
import cMonitoring from './c/monitoring'

const vueCookies = require('vue-cookies')

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/c',
      name: 'cDashboard',
      component: () => import('@/views/dashboard/Index.vue'),
      meta: {
        pageTitle: 'Dashboard',
        action: 'Lihat',
        resource: 'c-dashboard',
      },
    },
    {
      path: '/',
      redirect: '/b',
    },
    ...auth,
    ...monitoring,
    ...perkin,
    ...cetakDaftarBmd,
    ...cetakBarcode,
    ...validasiKeberadaan,
    ...dataInformasi,
    ...validasiBelumTercatat,
    ...cetakQrCode,
    ...laporan,
    ...beritaAcara,
    ...sptjm,
    // koreksi
    ...pengembalian, ...cleansing,

    /* Master */
    ...masterJenisRuangan,

    // bypass
    ...log,
    ...bypass,

    // B
    ...bSkTim,
    ...bDashboard,
    ...bPendalamanRegister,
    ...daftarBmd,
    ...hasilSensus,
    ...bMonitoring,
    ...bPerkin,
    ...bDokumenInventarisasi,
    ...bRuangan,
    ...bBeritaAcaraHasilInventarisasi,
    
    // C
    ...cMonitoring,
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = vueCookies.get('username')

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) {
      return next({ name: 'login' })
    }

    // If logged in => not authorized
    // return next({ name: 'bDashboard' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? 'admin' : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
